import React from 'react'
import PropTypes from 'prop-types'
import theme from 'styles/theme'

const styles = {
  container: {
    position: 'relative'
  },
  root: {
    width: 12,
    height: 12,
    opacity: 0.2,
    zIndex: 999,
    borderRadius: 6,
    cursor: 'pointer',
    border: '2px solid white',
    transition: 'all 0.3s ease',
    transform: 'translate(-50%, -50%)',
    backgroundColor: theme.palette.primary.main, 
  },
  active: {
    opacity: 1,
  },
  isArchived: {
    opacity: 1,
    backgroundColor: theme.palette.disabled.trap, 
  },
  activeLabel: {
    opacity: 0.9,
    transition: 'opacity .2s ease',
  }
}

class TrapMapIcon extends React.Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.isActive !== this.props.isActive
  }
  
  handleClick = (event) => {
    const { trap, onClick } = this.props

    if (onClick) {
      onClick(event, trap)
    }
  }
  render() {
    const { isActive, trap } = this.props
    const activeStyle = !trap.active ? styles.isArchived : isActive ? styles.active : {}

    const style = {
      ...styles.root,
      ...(activeStyle)
    }

    return (
      <div style={style} onClick={this.handleClick} />
    )
  }
}

TrapMapIcon.propTypes = {
  trap: PropTypes.object,
  onClick: PropTypes.func,
  isActive: PropTypes.bool,
}

export default TrapMapIcon



// WEBPACK FOOTER //
// ./src/components/atoms/TrapMapIcon.js